import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-column gap-2" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id"]

import { toRef, watch } from 'vue';
import { useField } from 'vee-validate';
import Dropdown from 'primevue/dropdown';
import { Nullable } from 'primevue/ts-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownWithLabel',
  props: {
    name: {},
    label: {},
    modelValue: {},
    optionLabel: { default: 'text' },
    optionValue: {},
    options: {},
    placeholder: { default: 'Chọn một' },
    smallLabel: {},
    showClear: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;



const { errorMessage, value } = useField<Nullable<string>>(toRef(props, 'name'), undefined, {
    initialValue: props.modelValue,
});
// watch(value, val => {
//     emit('update:modelValue', val);
// })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: _ctx.name }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.smallLabel)
        ? (_openBlock(), _createElementBlock("small", _hoisted_3, _toDisplayString(_ctx.smallLabel), 1))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2),
    _createVNode(_unref(Dropdown), {
      id: _ctx.name,
      modelValue: _unref(value),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
      class: _normalizeClass({ 'p-invalid': _unref(errorMessage) }),
      "aria-describedby": `${_ctx.name}-help`,
      "show-clear": _ctx.showClear,
      options: _ctx.options,
      "option-label": _ctx.optionLabel,
      "option-value": _ctx.optionValue,
      filter: "",
      placeholder: _ctx.placeholder
    }, null, 8, ["id", "modelValue", "class", "aria-describedby", "show-clear", "options", "option-label", "option-value", "placeholder"]),
    _createElementVNode("small", {
      id: `${_ctx.name}-help`,
      class: "p-error"
    }, _toDisplayString(_unref(errorMessage)), 9, _hoisted_4)
  ]))
}
}

})